import * as React from 'react'
import {FormControl, Theme, createStyles, withStyles, WithStyles, Input} from '@material-ui/core'
import {compose} from 'redux'
import autobind from 'autobind-decorator'
import { formatNumber } from '../utils/helpers';

const styles = (t: Theme) => createStyles({
    formControl: {
        width: '100%'
    },
});

interface IProps extends WithStyles<typeof styles>{
  input: any;
}


interface IStates {
    field: any;
}


class CurrencyField extends React.Component<IProps, IStates> {
  state = {
    field: formatNumber(this.props.input.value),
  };

  render() {
    const {classes} = this.props
    return (
        <FormControl className={classes.formControl}>
            <Input
                value={this.state.field}
                onChange={this.handleChange}
            />
        </FormControl>
    )
  }

  @autobind
  private handleChange(event: any){
    const { input} = this.props
    this.setState({field: formatNumber(this.convertToNumeric(event.target.value))})
    input.onChange(this.convertToNumeric(event.target.value))
  } 

  @autobind
  private convertToNumeric(input: string){
    return input.replace(/[^0-9.]/g,'').replace(/\s/g, '')
  }

  /* Need other solution for cursor
  @autobind
  private addAdornment(input: string, adornment: string){
    return input && input.length > 0 ? input + adornment : input
  }

  @autobind
  private removeAdornment(input: string, adornment: string){
    return input.replace(adornment,'')
  }

  @autobind
  private generateMask(field: string){
    const {adornment} = this.props
    return adornment ? this.addAdornment(formatNumber(this.convertToNumeric(field)), adornment) : formatNumber(this.convertToNumeric(field))
  }
  */

}

export default compose(
  withStyles(styles)
)(CurrencyField)



// WEBPACK FOOTER //
// ./src/shared/form/CurrencyField.tsx